/** Change discount percentage of product label based on variation **/
function updateDiscount() {

  jQuery(".sale.savings").each(function( index ) {

    var strArray = jQuery(this).text().match(/(\d+)/g);
    jQuery(this).closest('.product_section').eq(0).find('.campaign-badge > .discount-percentage').eq(0).text('-'+strArray[0]+'%');
    //jQuery(this).closest('.product_section').eq(0).find('.percentage-label').eq(0).text('-'+strArray[0]+'%');
  });

}

window.addEventListener('DOMContentLoaded', function() {
  var observer = new MutationObserver(function(e) {updateDiscount();});
  if(jQuery('.price-ui')[0]){
     observer.observe(jQuery('.price-ui')[0], {characterData: true, childList: true});
  }
  
});
